import React, { useEffect, useState } from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import CloseIcon from "../../../assets/images/clear.svg";
import TextField from "@material-ui/core/TextField";
import { withTranslation } from "react-i18next";
import { useStylesSecretSeedModal } from "../sharedComponent/style";
import { WalletResultCode, WalletValidator, SecretKey } from "boa-sdk-ts";
import { ErrorCheckUtil } from "../../../utils/ErrorCheckUtil";

const SecretSeedModal = (props) => {
  const classes = useStylesSecretSeedModal();
  const [secretKey, setSecretKey] = useState("");
  const [totalPrivateKeyCount, setTotalPrivateKeyCount] = useState(1);
  const [enterPrivateKeyCount, setEnterPrivateKeyCount] = useState(1);
  const [addressError, setAddressError] = useState("");
  const [openConfirmModal, setConfirmModal] = useState(false);
  const [address, setAddress] = useState("");
  const [index, setIndex] = useState(-1);
  const { t, readModeList, secretSeedModalCloseHandler, secretKeyModal } =
    props;

  useEffect(() => {
    if (readModeList && readModeList.length > 0 && index > -1) {
      setTotalPrivateKeyCount(readModeList.length);
      setEnterPrivateKeyCount(index + 1);
      setSecretKey("");
      setAddress(readModeList[index].address.toString());
    }
  }, [index]);

  useEffect(() => {
    if (secretKeyModal) {
      setIndex(0);
    } else {
      setIndex(-1);
    }
  }, [secretKeyModal]);

  // Method to check validation of private key and validateSecret against public key
  const checkSecretKeyHandler = async () => {
    let account = readModeList[index];

    const res = await WalletValidator.isValidSecretKeyAgainstPublicKey(
      secretKey,
      address
    );
    if (res.code === WalletResultCode.Success) {
      account.setSecret(new SecretKey(secretKey));
      if (readModeList.length > index + 1) {
        setIndex(index + 1);
      } else {
        props.secretSeedModalCloseHandler(true);
      }
    } else {
      setAddressError(ErrorCheckUtil.getLocaleMsg(res));
    }
  };

  const confirmAndDeniedModal = async (status) => {
    setConfirmModal(false);
    if (status) {
      setSecretKey("");
    }
  };

  return (
    // Secret Seed Modal Component
    <div>
      {/* Secret Key Modal component  */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={secretKeyModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={secretKeyModal}>
          <div className={`${classes.paper} ${"modalBg"}`}>
            <div className="counting">
              <p>{enterPrivateKeyCount}</p>
              <p>/</p>
              <p>{totalPrivateKeyCount}</p>
            </div>
            <h2 className="modalTitle" id="transition-modal-title">
              {t("Secret_Key")}
            </h2>
            <div className="modalInput label-color flexWrap">
              <TextField
                label={t("Public_Key")}
                value={address}
                disabled={true}
              />
            </div>
            <div className="modalInput label-color flexWrap">
              <TextField
                label={t("Secret_Key")}
                value={secretKey}
                onChange={(e) => setSecretKey(e.target.value)}
              />
            </div>
            <span className="validText" style={{ color: "red" }}>
              {addressError}
            </span>
            <div className="useful-info">
              <p>{t("Useful_Info_Line1")}</p>
              <p>{t("Useful_Info_Line2")}</p>
              <p>{t("Useful_Info_Line3")}</p>
            </div>
            <div className="modal_footer">
              <button
                className="senderBtn"
                onClick={(e) => checkSecretKeyHandler()}
              >
                {t("Ok")}
              </button>
              <button
                className="cancel_btn"
                onClick={()=>secretSeedModalCloseHandler(false)}
              >
                {t("Cancel")}
              </button>
            </div>
          </div>
        </Fade>
      </Modal>
      {/* Close confirm component  */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openConfirmModal}
        onClose={(e) => confirmAndDeniedModal(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openConfirmModal}>
          <div className={`${classes.paper} ${"modalBg"}`}>
            <img
              alt="CloseIcon"
              className="ClearModalImg"
              src={CloseIcon}
              onClick={(e) => confirmAndDeniedModal(false)}
            />
            <div className="modal-msg">
              <p>{t("Changes_exist_Are_you_sure_you_want_to_cancel")}</p>
            </div>
            <div className="modal_footer">
              <button
                className="senderBtn"
                onClick={(e) => confirmAndDeniedModal(true)}
              >
                {t("Yes")}
              </button>
              <button
                className="cancel_btn"
                onClick={(e) => confirmAndDeniedModal(false)}
              >
                {t("No")}
              </button>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default withTranslation()(SecretSeedModal);
